import { Formik, FormikDraftCAI, typedMemo } from "src/types";
import { useDataEntrySignatureAStep } from "./data-entry-signature-a-step.hook";
import { SignatureStep } from "src/ui/fragments";

export const DataEntrySignatureAStep = typedMemo(
  ({ formik }: { formik: Formik<FormikDraftCAI> }) => {
    const { createDossier } = useDataEntrySignatureAStep(formik);

    return <SignatureStep onSubmit={createDossier} />;
  },
);
